import { atom } from "recoil";

export const UpdateContactsFlagAtom = atom<boolean>({
  key: "UpdateContactsFlagAtom",
  default: false,
});
